module.exports = __webpack_public_path__ + "896ba606d656d5eb4b5383aac7460838.jpg";